import React from 'react';
import PropTypes from 'prop-types';
import '../styles/lineup.css';

const ROLE_LABEL = {
  headline: 'Headliner',
  support: 'Support',
};

const STATUS_LABEL = {
  draft: 'Draft',
  sent: 'Sent',
  accepted: 'Confirmed',
  declined: 'Declined',
};

const STATUS_CLASS = {
  draft: 'lineup-status lineup-status--draft',
  sent: 'lineup-status lineup-status--sent',
  accepted: 'lineup-status lineup-status--confirmed',
  declined: 'lineup-status lineup-status--declined',
};

function formatCurrency(amount) {
  if (amount == null) return '$0';
  const n = Number(amount);
  if (Number.isNaN(n)) return '$0';
  return `$${n.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}

function initials(name) {
  if (!name) return '?';
  return name.split(/\s+/).slice(0, 2).map((s) => s[0] || '').join('').toUpperCase();
}

const V3OfferLineupCard = ({ offer, isActive, onSelect, poolTake }) => {
  const role = ROLE_LABEL[offer.act_type] || 'Undefined';
  const status = STATUS_LABEL[offer.state] || offer.state || '';
  const statusClass = STATUS_CLASS[offer.state] || 'lineup-status';

  const cardClass = ['lineup-card', isActive ? 'lineup-card--active' : null]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={cardClass}
      onClick={() => onSelect(offer.id)}
      aria-label={offer.performer_name || 'Unnamed artist'}
    >
      <span className="lineup-card__avatar">
        {offer.performer_avatar_url
          ? <img src={offer.performer_avatar_url} alt="" />
          : <span className="lineup-card__avatar-initials">{initials(offer.performer_name)}</span>}
      </span>
      <span className="lineup-card__body">
        <span className="lineup-card__top">
          <span className="lineup-card__name">{offer.performer_name || 'Unnamed artist'}</span>
          <span className={statusClass}>{status}</span>
        </span>
        <span className="lineup-card__bottom">
          <span className="lineup-card__role">{role}</span>
          {/* O-2783: in Pool mode show the member's computed pool take; the
            * per-offer guarantee is 0 there. `null` → fall back to dollar_amount. */}
          <span className="lineup-card__amount">
            {formatCurrency(poolTake != null ? poolTake : offer.dollar_amount)}
          </span>
        </span>
      </span>
    </button>
  );
};

V3OfferLineupCard.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.number,
    act_type: PropTypes.string,
    performer_name: PropTypes.string,
    performer_avatar_url: PropTypes.string,
    state: PropTypes.string,
    dollar_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  isActive: PropTypes.bool,
  onSelect: PropTypes.func,
  poolTake: PropTypes.number,
};

V3OfferLineupCard.defaultProps = {
  offer: null,
  isActive: false,
  onSelect: () => {},
  poolTake: null,
};

export default V3OfferLineupCard;
